module.exports = __webpack_public_path__ + "img/loan_activity_navbar_bg.8ab76525.png";